import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Play, ArrowRight } from 'lucide-react';
import VideoGlow from '../media/VideoGlow';

// Brand video. Rendered as a standalone card that sits BETWEEN the hero and
// the "Everything a build needs" strip, pulled up with a negative top margin
// so it slightly overlaps the hero's bottom gradient. Text + CTA that used to
// wrap this video were removed - the video speaks for itself.
const ProcessSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  return (
    <div
      id="process"
      className="relative z-20 py-10 sm:py-14 px-5 sm:px-6 bg-white"
      data-testid="process-video"
    >
      <div className="max-w-[760px] lg:max-w-[820px] mx-auto">
        <VideoGlow poster="/video_thumbnail.jpg" className="rounded-2xl">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/15 ring-1 ring-black/5 bg-black">
          {!isPlaying && (
            <button
              type="button"
              onClick={handlePlay}
              aria-label="Play BuildPilot video"
              className="absolute inset-0 z-10 cursor-pointer group flex items-center justify-center focus:outline-none"
              data-testid="process-video-play"
            >
              <span className="w-16 h-16 sm:w-20 sm:h-20 gradient-blue-bg rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                <Play className="w-7 h-7 sm:w-8 sm:h-8 text-white ml-1" fill="white" />
              </span>
            </button>
          )}
          <video
            ref={videoRef}
            controls={isPlaying}
            playsInline
            preload="metadata"
            poster="/video_thumbnail.jpg"
            className="w-full aspect-video"
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            onEnded={() => setIsPlaying(false)}
          >
            <source src="/videos/buildpilot-commercial.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        </VideoGlow>
        <div className="mt-5 text-center">
          <Link
            to="/how-it-works"
            data-testid="process-video-watch-link"
            className="inline-flex items-center gap-1.5 text-[14px] font-semibold text-[#1d8efe] hover:gap-2.5 transition-all"
          >
            See how BuildPilot works
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProcessSection;
